import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";

import "./index.css";
import MainLayout from "./layouts/MainLayout";
import LandingPage from "./components/LandingPage";

const routes = createRoutesFromElements(
  <Route path="/" element={<MainLayout />}>
    <Route path={'/'} element={<LandingPage />} />
  </Route>
);

const root = createBrowserRouter(routes);
function App() {
  return (
    <div className="App">
      <RouterProvider router={root} />
    </div>
  );
}

export default App;
